import { Stack } from "@mui/material";
import { useRef } from "react";
import MeshGradient from "./MeshGradient";

const Background = ({ children }) => {
  const containerRef = useRef();
  return (
    <Stack
      ref={containerRef}
      sx={{
        width: "100%",
        minHeight: "100vh",
        position: "relative",
      }}
      spacing={4}
    >
      <MeshGradient />
      {children}
    </Stack>
  );
};

export default Background;
